module.exports = __webpack_public_path__ + "resources/img/img_hi_psm3_m.b0e3d947ca630b50ab8f9dd51cb04c38.png";